import Http from '../Core/Http';
export default class Inspection extends Http {
  constructor(config) {
    super(config);
  }
  // 获取预约总数
  GetAppointNum(){
    return this._post('/api/NucleicAcid/GetAppointNum', null, null);
  }
  // 查询已预约数量
  GetAppointSurplusNum(data){
    return this._post('/api/NucleicAcid/GetAppointSurplusNum', null, data);
  }
  // 填写预约记录
  AddNucleicAcid(data){
    return this._post('/api/NucleicAcid/AddNucleicAcid', null, data);
  }
  GetAppointList(data){
    return this._post('/api/NucleicAcid/GetAppointList', null, data);

  }
}



// WEBPACK FOOTER //
// ./src/lib/PMA/inspection.js